import React from "react";
import { FaSearch, FaFilter, FaChevronDown, FaChevronUp } from "react-icons/fa";

const ClubsDojoFilters = ({
  searchTerm,
  setSearchTerm,
  selectedDepartement,
  setSelectedDepartement,
  sortBy,
  setSortBy,
  departementOptions,
  totalResults,
  onToggleExpandAll,
  allExpanded,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-slate-800 dark:text-slate-100">
        <FaFilter className="text-sky-600 dark:text-sky-400" />
        <h2 className="text-lg font-semibold">Recherche & filtres</h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-3">
        <div className="lg:col-span-5">
          <label className="text-sm font-medium text-slate-700 dark:text-slate-200">
            Recherche
          </label>
          <div className="mt-1 relative">
            <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Nom du club, dojo, adresse, utilisateur..."
              className="w-full rounded-2xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 px-10 py-3 text-sm outline-none focus:ring-2 focus:ring-sky-500/30"
            />
          </div>
        </div>

        <div className="lg:col-span-3">
          <label className="text-sm font-medium text-slate-700 dark:text-slate-200">
            Département
          </label>
          <select
            value={selectedDepartement}
            onChange={(e) => setSelectedDepartement(e.target.value)}
            className="mt-1 w-full rounded-2xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-sky-500/30"
          >
            <option value="">Tous les départements</option>
            {departementOptions.map((dep) => (
              <option key={dep} value={dep}>
                {dep}
              </option>
            ))}
          </select>
        </div>

        <div className="lg:col-span-2">
          <label className="text-sm font-medium text-slate-700 dark:text-slate-200">
            Trier par
          </label>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="mt-1 w-full rounded-2xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-sky-500/30"
          >
            <option value="name">Nom du club</option>
            <option value="departement">Département</option>
            <option value="dojos_desc">Nb de dojos</option>
            <option value="groups_desc">Nb de groupes</option>
          </select>
        </div>

        <div className="lg:col-span-2 flex items-end">
          <button
            onClick={onToggleExpandAll}
            className="w-full inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-3 bg-slate-900 text-white hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100 transition"
          >
            {allExpanded ? <FaChevronUp /> : <FaChevronDown />}
            {allExpanded ? "Tout replier" : "Tout déplier"}
          </button>
        </div>
      </div>

      <div className="text-sm text-slate-500 dark:text-slate-400">
        {totalResults} résultat{totalResults > 1 ? "s" : ""}
      </div>
    </div>
  );
};

export default ClubsDojoFilters;